export class InfluencerPreloadData {
  public influencerList: any[];
  public postList: any[];
  public topExposureList: any;
  public bestPerformingList: any;
  public dailyKpiList: any[];
  public campaignInfluencerList: any[];
  public campaignPostList: any[];
  public campaignInfluencerDetails: any[];
  constructor() {
    this.influencerList = [];
    this.postList = [];
    this.topExposureList = {};
    this.bestPerformingList = {};
    this.dailyKpiList = [];
    this.campaignPostList = [];
    this.campaignInfluencerDetails = [];
    this.campaignInfluencerList = [];
  }
}



// WEBPACK FOOTER //
// ./src/models/influencer-preload-data.ts